import { render, staticRenderFns } from "./DigitSeparatorsField.vue?vue&type=template&id=c31dc524&lang=pug"
import script from "./DigitSeparatorsField.vue?vue&type=script&lang=js"
export * from "./DigitSeparatorsField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports